import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-textarea-input',
    standalone: false,
    templateUrl: './textarea-input.component.html',
    styleUrl: './textarea-input.component.scss',
})
export class TextareaInputComponent extends InputComponent {}
